import type { CalculatedSemNode } from 'types/data/CalculatedSemNode';
import CalculateNodesWorker from 'worker-loader!./calculateNodes.worker';

import { promisifyWorker } from './promisifyWorker';
import type { CalculateNodesProps } from './utils/calculateNodes';

const calculateNodesAsync = promisifyWorker<CalculateNodesProps, CalculatedSemNode[]>(new CalculateNodesWorker());

export { calculateNodesAsync };
